import { Button, Container, RadioGroup, FormControlLabel, Radio, Typography, Grid, TextField, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import React, { useEffect, useState } from 'react';
import * as azblob from '@azure/storage-blob';


const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    input: {
        display: 'none',
    },
}));

const DigiSpelForm = (props) => {

    useEffect(() => {
        //console.log("DIGIPRAATFORM PROPS:", props);
        if (!props.isAuth.userAuth) {
            props.history.push('tekenin');
        }
        else {
            setInskrywingInfo({ ...inskrywing, "inskrywerId": props.userProf.userProfile.id })
        }

    }, [])

    const classes = useStyles();
    const [status, reportStatus] = useState('Oplaai het begin...');
    const [isUploading, setIsUploading] = useState(false);
    const [vid, setVid] = useState("GEEN");
    const [vidOpgelaai, setVidOpgelaai] = useState(false);
    const [formIsInValid, setFormIsInvalid] = useState(true);
    const [isBemagtig, setIsBemagtig] = useState(true);
    const [bewyse, setBewyse] = useState("GEEN");
    const [bewyseOpgelaai, setBewyseOpgelaai] = useState(false)

    const [inskrywing, setInskrywingInfo] = useState({
        "inskrywerId": "",
        "naamVan": "",
        "ouerNaamVan": "",
        "ouerSel": "",
        "ouerEpos": "",
        "sel": "",
        "epos": "",
        "kategorie": "",
        "instansieNaam": "",
        "ouerBemagtigingGegee": false,
        "bewyseGelaai": false

    });
    const [inskrywingId, setInskrywingId] = useState();


    const accountName = "projektestorage";
    const sasString = process.env.REACT_APP_STORAGE_ACCOUNT_ACCESS_KEY;
    const containerName = "digispel";
    const containerURL = new azblob.ContainerURL(
        `https://${accountName}.blob.core.windows.net/${containerName}?${sasString}`,
        azblob.StorageURL.newPipeline(new azblob.AnonymousCredential));
    //const fileList = document.getElementById("file-list");
    const fileInput = document.getElementById("vid-input");
    const bewyseInput = document.getElementById("bewyse-input");


    const style = {

        padding: "20px",
    }


    const formChange = (e) => {
        if (e.target.type === "radio") {
            setInskrywingInfo({ ...inskrywing, [e.target.name]: e.target.value });
        }
        else if (e.target.type === "checkbox") {
            setInskrywingInfo({ ...inskrywing, [e.target.name]: e.target.checked });

        }
        else {
            setInskrywingInfo({ ...inskrywing, [e.target.id]: e.target.value });
        }
    }

    const finishRegistration = async () => {
        //start upload ui
        setIsUploading(true);
        //insert record for inskrywing into db
        fetch('api/UserEntries/digispel/new', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(inskrywing)
        })
            .then((response) => response.json())
            .then((data) => {
                setInskrywingId(data.id);
                //console.log('data logged as reposne', data);
            })

    }

    const uploadVidToBlob = async () => {
        //await finishSubmit();
        reportStatus("Besig om op te laai, gee asseblief 1-2 minute tyd...");
        const promises = [];
        for (const file of bewyseInput.files) {
            const blockBlobURL = azblob.BlockBlobURL.fromContainerURL(containerURL, inskrywing.naamVan + "-" + inskrywing.inskrywerId + "-inskrywing-bewyse-" + inskrywingId);
            promises.push(azblob.uploadBrowserDataToBlockBlob(
                azblob.Aborter.none, file, blockBlobURL));
        }
        await Promise.all(promises);
        reportStatus("Sukses!");
        setIsUploading(false);
        window.setTimeout(props.history.push('suksesinskryf'), 1000);
    }

    const bewyseInputChange = () => {
        if (document.getElementById("bewyse-input").value != "") {
            setBewyse("Bewyse van betaling gekies!");
            setBewyseOpgelaai(true);
            setInskrywingInfo({ ...inskrywing, "bewyseGelaai": true })
        }
        else {
            setBewyse("");
            setBewyseOpgelaai(false);
            setInskrywingInfo({ ...inskrywing, "bewyseGelaai": false })


        }

    }


    //unneccessary for production
    useEffect(() => {
        //console.log('loigging props on digipraatform', props);
        console.log('logging inskrywing state', inskrywing);
    }, [])

    useEffect(() => {
        if (inskrywingId !== undefined) {
            //wait for id to be returned before uploading video to azureblob
            //window.alert('BEGIN VIDEOMATERIAAL LAAI, ASSEBLIEF WEES GEDULDIG');
            uploadVidToBlob();
        }
    }, [inskrywingId])

    useEffect(() => {
        //console.log("DIGIPRAATFORM PROPS:", props);
        if (!props.isAuth.userAuth) {
            props.history.push('tekenin');
        }

    }, [])

    useEffect(() => {
        //as inskrywing verander, kyk of vorm leeg is

        //console.log('Inskrywing:', inskrywing);
        var isValid = true;

        for (var property in inskrywing) {
            if (property === "ouerBemagtigingGegee") {
                if (inskrywing["ouerBemagtigingGegee"] === false) {
                    isValid = false;
                }
            }
            else if (property === "vidGelaai") {
                if (inskrywing["vidGelaai"] === false) {
                    isValid = false;
                }
            }
            else if (property === "bewyseGelaai") {
                if (inskrywing["bewyseGelaai"] === false) {
                    isValid = false;
                }
            }

            else if (inskrywing[property] === "") {
                isValid = false;
            }
            //console.log(`key= ${property} value = ${inskrywing[property]}`)
        }
        if (isValid) {
            setFormIsInvalid(false);
        }
        else {
            setFormIsInvalid(true);
        }


    }, [inskrywing])


    return (
        <Container className="container" style={style}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} lg={6}>
                    <Typography variant="h5" gutterBottom>Ouer/voog/afrigter se besonderhede</Typography>

                    <TextField onChange={formChange} id="ouerNaamVan" required label="Naam en van" variant="outlined" margin="normal" fullWidth />

                    <TextField onChange={formChange} id="ouerSel" label="Selfoonnommer" variant="outlined" margin="normal" fullWidth />

                    <TextField onChange={formChange} id="ouerEpos" label="E-posadres" variant="outlined" margin="normal" type="email" fullWidth />

                    <Typography variant="h5" gutterBottom>Ouermagtiging</Typography>
                    <Grid container>
                        <Grid item xs={2} lg={2}>
                            <Checkbox
                                onChange={formChange}
                                color="primary"
                                name="ouerBemagtigingGegee"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                        </Grid>
                        <Grid item xs={10} lg={10}>
                            <Typography variant="h6" gutterBottom>
                                {
                                    //important notice to be ticked
                                }
                                    Hiermee gee ek toestemming dat my kind aan ATKV-DigiSpel mag deelneem.
                                </Typography>
                        </Grid>
                    </Grid>


                </Grid>
                <Grid item xs={12} sm={6} lg={6}>
                    <Typography variant="h5" gutterBottom>Besonderhede van deelnemer</Typography>

                    <TextField onChange={formChange} id="naamVan" label="Naam en Van" variant="outlined" margin="normal" fullWidth />

                    <TextField onChange={formChange} id="sel" label="Selfoonnommer" variant="outlined" margin="normal" fullWidth />

                    <TextField onChange={formChange} id="epos" label="E-posadres" variant="outlined" margin="normal" fullWidth />

                    <TextField onChange={formChange} multiline id="instansieNaam" label="Naam van opvoedkundige instansie" variant="outlined" margin="normal" fullWidth />

                    <Typography variant="h5" gutterBottom>Kategorie</Typography>
                    <RadioGroup name="kategorie" aria-label="kategorie" onChange={formChange}>
                        <Grid item xs={12}>
                            <FormControlLabel value="gr1" control={<Radio color="primary" />} label="Graad 1" />
                            <FormControlLabel value="gr23" control={<Radio color="primary" />} label="Graad 2 - 3" />
                            <FormControlLabel value="gr45" control={<Radio color="primary" />} label="Graad 4 - 5" />
                            <FormControlLabel value="gr67" control={<Radio color="primary" />} label="Graad 6 - 7" />
                            <FormControlLabel value="gr89" control={<Radio color="primary" />} label="Graad 8 - 9 " />
                            <FormControlLabel value="gr1012" control={<Radio color="primary" />} label="Graad 10 - 12" />
                            <FormControlLabel value="volwassene" control={<Radio color="primary" />} label="Volwassenes" />
                        </Grid>
                    </RadioGroup>
                    {/* 
                     * Bewys van betaling
                     */}
                    <div className={classes.root}>
                        <Typography variant="h6" gutterBottom>Bewys van betaling</Typography>
                        <Button
                            variant="contained"
                            component="label"
                            color="primary"
                        >
                            Betalingsoplaaifunksie
                        <input
                                id="bewyse-input"
                                type="file"
                                style={{ display: "none" }}
                                onChange={bewyseInputChange}
                                accept=".pdf"

                            />
                        </Button>
                        {bewyseOpgelaai ? <p> {bewyse} </p> : <p> </p>}

                    </div>
                    {/* 
                     * END Bewys van betaling END
                     */}

                </Grid>
                <Grid container justify="center">
                    {isUploading ? <Grid item> <CircularProgress /> <Typography variant="body1" gutterBottom>{status}</Typography> </Grid> : <br />}
                </Grid>

                <Grid container justify="center">
                    <Grid>
                        <Button variant="contained" size="large" color="primary" disabled={formIsInValid} onClick={finishRegistration}>Registreer vir ATKV-DigiSpel</Button>
                        {/* <Button variant="contained" size="large" color="primary" disabled="true" onClick={finishRegistration}>Registreer vir ATKV-DigiSpel</Button> */}

                    </Grid>
                </Grid>
            </Grid>
        </Container>
    )

}


export default DigiSpelForm;


// WEBPACK FOOTER //
// ./src/components/inskrywingsvorms/DigiSpelForm.js